import { render, staticRenderFns } from "./email-password-change.vue?vue&type=template&id=6bb239f2&"
import script from "./email-password-change.vue?vue&type=script&lang=js&"
export * from "./email-password-change.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports